export default __webpack_public_path__ + "00905f17d498935a915fc8e98a10b164.svg";